import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { MainLayout } from "./main";
import { Security } from "@okta/okta-react"
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { Analysis } from "../pages/Analysis";
// import { Settings } from './settings/index';
import { Home } from "../pages/Home";
import { OKTA_CLIENT } from "../constants/env";
import * as global from "../contexts/GlobalAppContext";
import { Form } from "../pages/Form";
import { Settings } from "../pages/Settings";
import { Overview } from "../pages/Overview";

const oktaClientId = OKTA_CLIENT;

const oktaAuth = new OktaAuth({
    issuer: "https://braze.okta.com", 
    clientId: oktaClientId,
    redirectUri: window.location.origin,
    scopes: ["openid", "profile", "email", "offline_access"],
    pkce: false,
});

export const RootPage = () => {


    const restoreOriginalUri = async (
        _oktaAuth: OktaAuth,
        originalUri: string
    ) => {
        window.location.replace(toRelativeUrl(originalUri || "/", window.location.origin));
        
    };
        
    
      
    return (

        <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
            <Router>
                <global.Provider>
                    <MainLayout>
                        <Routes>
                            <Route path ="/" Component={Home}/>
                            <Route path ="/logout" Component={Home}/>
                            <Route path ="/campaign-overview" Component={Overview}/>
                            <Route path ="/campaign-form" Component={Form}/> 
                            <Route path ="/campaign-analysis" Component={Analysis}/> 
                            <Route path = "/settings" Component={Settings}/> 
                        </Routes>
                    </MainLayout>
                </global.Provider>
            </Router>
        </Security>
        
        
        
    )
}